import React from 'react'
import './index.less'
import { Toast } from 'antd-mobile'
import BandCardStatusDialog from './../../compontents/plusPageCompontents/BandCardStatusDialog/index'
class PlusMyAssetDialog extends React.Component {
    constructor() {
        super()
        this.state = {
            confirmText: '您未绑定银行卡，请完成绑定',
            showDialog: false, // 白条绑卡的状态
            isBtn: true
        }
    }

    componentDidMount() {
        const loading = document.querySelector('.page-loading')
        loading.style.opacity = 0
        loading.style.zIndex = -1
        loading.style.display = 'none'
    }

    componentWillUnmount() {
        localStorage.removeItem('data')
    }

    // 处理可售额度 千分符 100,000
    handleNum = (num) => {
        num = num && num.toString()
        const AMOUNT_REG = /(\d)(?=(?:(\d{3})|\d{3}\.\d+)+$)/g
        return num ? num.replace(AMOUNT_REG, '$1,') : '--'
    }

    checkStatus = (item) => {
        const isFrozen = item.amountStatus === '020' || item.amountStatus === '030'
        if (item.accountStatus === '052') {
            if (item.amountStatus === '010') { // 白条额度状态 010：可用
                if (item.bindCardState === '010') { // 是否已绑卡{010：是}
                    if (item.cardState !== '0') {
                        this.setState({
                            confirmText: '您的默认银行卡信息已过期，请重新绑定',
                            isBtn: true,
                            showDialog: true
                        })
                        return
                    }
                    if (item.quotaInfoResCode === '0000') {
                        if (item.quotaInfoHasMobile === '0') {
                            this.setState({
                                confirmText: '您的账户尚未绑定手机号，请前往“我的”--＞“设置”--＞“账户安全”--＞“手机验证”进行绑定。',
                                isBtn: false,
                                showDialog: true
                            })
                        } else if (item.quotaInfoHasMobile === '1') {
                            if (item.quotaInfoFlag === '0') {
                                window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/borrow.html?isFrozen=${isFrozen}`)
                            } else {
                                switch (item.quotaInfoFlag) {
                                    case '14':
                                        window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/authen.html?toPage=borrow`)
                                        break
                                    default:
                                        Toast.info(`${item.quotaInfoResDesc}`, 1)
                                }
                            }
                        }
                    } else {
                        Toast.info(`${item.quotaInfoResDesc}`, 1)
                    }
                } else if (item.bindCardState === '020') { // 是否已绑卡{020：否}
                    this.setState({
                        confirmText: '您未绑定银行卡，请完成绑定',
                        isBtn: true,
                        showDialog: true
                    })
                }
            } else if (item.amountStatus === '020') { // 白条额度状态 020：冻结；
                Toast.info('您的易卡已处于永久冻结状态，无法进行易卡消费', 1)
            } else if (item.amountStatus === '030') { // 白条额度状态 030：临时冻结
                Toast.info('您的易卡已处于临时冻结状态，无法进行易卡消费', 1)
            }
        }
    }

    // 绑定银行卡
    tobind = () => {
        window.GomeJSBridge.pushWindow(null, null, `${process.env.REACT_APP_MEIYIFEN_HTML}dist/bankcard.html?from=pay&fromIndex=true&cert=true`)
    }

    handleShowDialog = () => {
        this.setState({
            showDialog: !this.state.showDialog
        })
    }

    render() {
        const data = JSON.parse(localStorage.getItem('data')) || {}
        console.log(data)
        const { showDialog, confirmText, isBtn } = this.state
        return (
            <React.Fragment>
                {/* <Overlay /> */}
                <div className={'plusMyAssetDialogContainer'}>
                    <div className={'plusMyAssetDialogTopContainer'}>
                        <div className={'plusMyAssetDialogTop'}>
                            <p>可用额度(元)</p>
                            <p>{this.handleNum(parseInt(data.availableAmount))}</p>
                            <p />
                            <p>
                                <span>提现额度</span>
                                <span>{this.handleNum(parseInt(data.expressiveAmount))}元</span>
                            </p>
                        </div>
                    </div>
                    <p className={'plusMyAssetDialogCenter'}>
                        <span>单向额度</span>
                        <span>以下为单向产品总额度</span>
                    </p>
                    <ul className={'plusMyAssetDialogBottom'}>
                        <li className={'plusMyAssetItem'} onClick={() => {
                            window.GomeJSBridge.popWindow()
                        }}>
                            <p>
                                <span className={'cashIcon'} />
                                <span>消费分期</span>
                            </p>
                            <p>￥{this.handleNum(parseInt(data.consumeAmount))}</p>
                        </li>
                        <li className={'plusMyAssetItem'} onClick={() => {
                            this.checkStatus(data)
                        }}>
                            <p>
                                <span className={'plusOnlineIcon'} />
                                <span>现金分期</span>
                            </p>
                            <p>￥{this.handleNum(parseInt(data.cashAmount))}</p>
                        </li>
                    </ul>
                </div>
                {showDialog && <BandCardStatusDialog
                    confirmText={confirmText}
                    handleShowDialog={this.handleShowDialog}
                    tobind={this.tobind}
                    isBtn={isBtn}
                />}
            </React.Fragment>

        )
    }
}

export default PlusMyAssetDialog
